import { createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-14b1bafc"),n=n(),_popScopeId(),n)
const _hoisted_1 = /*#__PURE__*/_createTextVNode(" Без пациента (быстрый отчет без выбора пациента) ")
const _hoisted_2 = /*#__PURE__*/_createTextVNode(" Существующий ")
const _hoisted_3 = /*#__PURE__*/_createTextVNode(" Создать нового ")

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_el_radio = _resolveComponent("el-radio")!
  const _component_search_patient = _resolveComponent("search-patient")!
  const _component_patient_creation_form = _resolveComponent("patient-creation-form")!
  const _component_el_radio_group = _resolveComponent("el-radio-group")!

  return (_openBlock(), _createBlock(_component_el_radio_group, {
    modelValue: _ctx.reportCreationMode,
    "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.reportCreationMode) = $event)),
    class: "choice-creation-mode"
  }, {
    default: _withCtx(() => [
      _createVNode(_component_el_radio, {
        class: "choice-creation-mode__radio",
        label: _ctx.REPORT_CREATION_MODE.nullPatient
      }, {
        default: _withCtx(() => [
          _hoisted_1
        ]),
        _: 1
      }, 8, ["label"]),
      _createVNode(_component_el_radio, {
        class: "choice-creation-mode__radio",
        label: _ctx.REPORT_CREATION_MODE.patientExists
      }, {
        default: _withCtx(() => [
          _hoisted_2
        ]),
        _: 1
      }, 8, ["label"]),
      (_ctx.reportCreationMode === _ctx.REPORT_CREATION_MODE.patientExists)
        ? (_openBlock(), _createBlock(_component_search_patient, { key: 0 }))
        : _createCommentVNode("", true),
      _createVNode(_component_el_radio, {
        class: "choice-creation-mode__radio",
        label: _ctx.REPORT_CREATION_MODE.newPatient
      }, {
        default: _withCtx(() => [
          _hoisted_3
        ]),
        _: 1
      }, 8, ["label"]),
      (_ctx.reportCreationMode === _ctx.REPORT_CREATION_MODE.newPatient)
        ? (_openBlock(), _createBlock(_component_patient_creation_form, { key: 1 }))
        : _createCommentVNode("", true)
    ]),
    _: 1
  }, 8, ["modelValue"]))
}